export default {
  defaultLocale: 'en',
  locales: ['en', 'ru'],
  messenger_loggedInGreeting: {
    en: 'Hare Krishna! How can we serve you?',
    ru: 'Харе Кришна! Как мы можем Вам послужить?'
  },
  messenger_loggedOutGreeting: {
    en: 'Hare Krishna! How can we serve you?',
    ru: 'Харе Кришна! Как мы можем Вам послужить?'
  },
  nav_map: {
    en: 'Map',
    ru: 'Карта'
  },
  nav_stream: {
    en: 'TV',
    ru: 'ТВ'
  },
  nav_today: {
    en: 'Today',
    ru: 'Сегодня'
  },
  nav_news: {
    en: 'News',
    ru: 'Новости'
  },
  nav_calendar: {
    en: 'Calendar',
    ru: 'Календарь'
  },
  nav_forum: {
    en: 'Forum',
    ru: 'Форум'
  },
  nav_shop: {
    en: 'Shop',
    ru: 'Магазин'
  },
  home_title: {
    en: 'Home',
    ru: 'Главная'
  },
  map_title: {
    en: 'Map',
    ru: 'Карта'
  },
  map_select_category: {
    en: 'Select category...',
    ru: 'Выберите категорию...'
  },
  today_title: {
    en: 'Today',
    ru: 'Сегодня'
  },
  news_title: {
    en: 'News',
    ru: 'Новости'
  },
  forum_title: {
    en: 'Forum',
    ru: 'Форум'
  },
  shop_title: {
    en: 'Shop',
    ru: 'Магазин'
  },
  stream_title: {
    en: 'Stream',
    ru: 'Трансляция'
  },
  support_project_title: {
    en: 'Support Project',
    ru: 'Поддержать проект'
  },
  tags: {
    en: 'Tags',
    ru: 'Теги'
  },
  home_quote: {
    en: 'My idea is to attract people of the whole world to Mayapur.',
    ru: 'Моя идея - привлечь людей всего мира в Маяпур.'
  },
  home_prabhupada: {
    en: 'Srila Prabhupada',
    ru: 'Шрила Прабхупада'
  },
  home_prabhupadaStatus: {
    en: 'the Founder-Ācārya of ISKCON',
    ru: 'Ачарья-Основатель ИСККОН'
  },
  searchPlaceholder: {
    en: 'Search',
    ru: 'Поиск'
  },
  footer_project_team: {
    en: 'Team',
    ru: 'Команда'
  },
  footer_donate: {
    en: 'Donate',
    ru: 'Пожертвовать'
  },
  footer_developed_by: {
    en: 'Developed by',
    ru: 'Разработано'
  },
  donations_support_mayapur_live: {
    en: 'Support Mayapur Live',
    ru: 'Поддержите Маyapur Live'
  },
  donations_description: {
    en: 'Your donations directly support website and its development. Lets help Srila Prabhupada and Lord Chaitanya to spread the glory of Sri Mayapur Dham and Sankirtana Yajna all over the World!',
    ru: 'Ваши пожертвования напрямую поддерживают работу сайта и его развитие. Давайте вместе поможем Шриле Прабхупаде и Господу Чайтанье распространить славу Шри Маяпур Дхамы и Санкиртана Ягьи по всему миру!'
  },
  donations_supporter_button: {
    en: 'Become a Supporter',
    ru: 'Стать Хранителем'
  },
  donations_one_time_button: {
    en: 'One time donation',
    ru: 'Разовое пожертвование'
  },
  donations_gold_supporters: {
    en: 'Gold Supporters',
    ru: 'Золотые Хранители'
  },
  donations_silver_supporters: {
    en: 'Silver Supporters',
    ru: 'Серебрянные Хранители'
  },
  donations_bronze_supporters: {
    en: 'Bronze Supporters',
    ru: 'Бронзовые Хранители'
  },
  in_development: {
    en: 'Feature in development...',
    ru: 'Функционал в разработке...'
  },
  content_published: {
    en: 'Published',
    ru: 'Опубликовано'
  },
  content_table_title: {
    en: 'Titled',
    ru: 'Заголовок'
  },
  content_table_image: {
    en: 'Image',
    ru: 'Картинка'
  },
  content_table_gallery: {
    en: 'Gallery',
    ru: 'Галерея'
  },
  content_table_category: {
    en: 'Category',
    ru: 'Категория'
  }
}
